import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
import { ExpensesCategory } from "../expenses-category/expenses-category.entity";


@Entity('expenses_sub_category')
export class ExpensesSubCategory {

  @PrimaryGeneratedColumn("increment",{name:'expenses_sub_category_id'})
  expensesSubCategoryId:number;

  @Column("char",{
      nullable:false,
      length:50,
      name:"expenses_sub_category"
      })
  // @Index({ unique: true })
  expensesSubCategory:string;

  @Column("boolean",{
    nullable:false,
    default:true,
    name:"is_active"
    })
  isActive:boolean;
  
  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("varchar", {
      nullable: false,
      default:1,
      name: "created_user"
  })
  createdUser: string | null;


  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
      nullable: true,
      name: "updated_user"
  })
  updatedUser: string | null;


  @VersionColumn({
      default:1,
      name: "version_flag"
  })
  versionFlag: number;

  @ManyToOne(type=>ExpensesCategory, expensesCatego=>expensesCatego.expensesSubCategoryInfo,{  nullable:false, })
  @JoinColumn({ name:"expenses_category_id"})
  expensesCategoryInfo: ExpensesCategory;
  

 

}
